/**
 * Реплейсит ключи в шаблонное строке по заданому объекту с данными, где ключ в строке совпадают с ключами в объекте
 * @param tpl
 * @param oKeys
 * @returns {*}
 */
export default function setContent (tpl, oKeys) {
	let buffer = tpl;

	Object.keys(oKeys).forEach(key => {
		let regExp = new RegExp(`__${key}__`, 'gi');
		let temp = [];

		if (!Array.isArray(oKeys[key])) oKeys[key] = [oKeys[key]];

		oKeys[key].forEach((item) => {
			/* eslint-disable */
			/**
			 * ключи нужно писать с namespace-ами, чтоб небыло пересечений
			 */
			switch (key) {
				case 'iw-metro':
					temp.push(`
						${item.is ? `
							<div class="gcell gcell--auto _flex-noshrink">
								<div class="building-card__metro ${item.name ? 'has-tooltip' : ''}">
									<i class="svgi svgi--metro _fill-metro-${item.type}">
										<svg viewBox="0 0 20 20" width="20" height="20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#metro"></use></svg>
									</i>
									${item.name ? `
										<div class="tooltip tooltip--top tooltip--sm tooltip--white tooltip--building-card building-card__tooltip">
											<span class="tooltip__text">${item.name}</span>
										</div>
									` : ''}
								</div>
							</div>
						` : ''}
					`);
					break;



				case 'iw-price':
					temp.push(`
						<div class="grid grid--vspaces-sm _items-baseline">
							${Object.keys(item).map(price => {
								if (price.toLocaleLowerCase() === 'full') {
									return `
										<div class="gcell gcell--auto">
							 				<div class="building-card__price-full mark mark--yellow">${item[price]}</div>
							 			</div>
									`;
								} else if (price.toLocaleLowerCase() === 'part') {
									return `
										<div class="gcell gcell--auto">
							 				<div class="building-card__price-part">(${item[price]})</div>
							 			</div>
									`;
								}
							}).join('')}
						</div>
					`);
					break;

				case 'ss-list':
					temp.push(`
						<li class="site-search__suggestion-item">
							<div class="site-search__icon">
								${item.hint ? `
									<i class="svgi svgi--building">
										<svg viewBox="0 0 18 18" width="18" height="18"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#jk"></use></svg>
									</i>
								` :
									`<i class="svgi svgi--developer">
										<svg viewBox="0 0 18 18" width="18" height="18"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#zastrou"></use></svg>
									</i>`}
							</div>
							<div>
								<a href="${item.link}" class="site-search__suggestion-link">${item.name}</a>
							</div>
							${item.hint ? `
								<div class="site-search__suggestion-hint">${item.hint}</div>
							` : ''}
						</li>
					`);
					break;

				default:
					buffer = buffer.replace(regExp, oKeys[key]);
					break;
			}
		});

		buffer = buffer.replace(regExp, temp.join(''));
	});

	return buffer;
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_utils/setContent.js